import { useState } from 'react';
import { Drawer, Input, Select, Table, Space, Button, Tag } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { api, type ArticleRow } from '../api/client';

interface Props {
  open: boolean;
  excludeId: string;
  selectedIds: string[];
  onClose: () => void;
  onConfirm: (ids: string[]) => void;
}

/** 全版 Drawer：用 title / 作者篩選後挑選關聯文章（限 post）。 */
export default function RelatedDrawer({ open, excludeId, selectedIds, onClose, onConfirm }: Props) {
  const [title, setTitle] = useState('');
  const [authorId, setAuthorId] = useState<string | undefined>();
  const [picked, setPicked] = useState<string[]>(selectedIds);

  const users = useQuery({ queryKey: ['users'], queryFn: api.users, enabled: open });
  const params: Record<string, string> = { pageSize: '50', kind: 'post' };
  if (title) params.title = title;
  if (authorId) params.authorId = authorId;
  const list = useQuery({
    queryKey: ['related-search', params],
    queryFn: () => api.listArticles(params),
    enabled: open,
  });

  const rows = (list.data?.items ?? []).filter((a) => a.id !== excludeId);

  return (
    <Drawer
      title="挑選關聯文章"
      open={open}
      onClose={onClose}
      width="100%"
      extra={
        <Space>
          <Tag>{picked.length} 篇已選</Tag>
          <Button onClick={onClose}>取消</Button>
          <Button type="primary" onClick={() => onConfirm(picked)}>
            確定
          </Button>
        </Space>
      }
    >
      <Space className="mb-4" wrap>
        <Input.Search placeholder="以標題搜尋" allowClear className="w-72" onSearch={setTitle} />
        <Select
          placeholder="依作者篩選"
          allowClear
          className="w-52"
          onChange={setAuthorId}
          options={(users.data ?? []).map((u) => ({ value: u.id, label: u.displayName }))}
        />
      </Space>
      <Table<ArticleRow>
        rowKey="id"
        loading={list.isLoading}
        dataSource={rows}
        pagination={false}
        scroll={{ y: '60vh' }}
        rowSelection={{
          selectedRowKeys: picked,
          onChange: (keys) => setPicked(keys as string[]),
        }}
        columns={[
          { title: '標題', dataIndex: 'title' },
          { title: '狀態', dataIndex: 'status', width: 100 },
        ]}
      />
    </Drawer>
  );
}
